module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NyA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTM3LjE5NTIgNDQuMDc2MkwwLjgzMDM2MSA0Ljk0MzYyTDQ2LjQ5ODYgMC4yNzE3NTZMMzcuMTk1MiA0NC4wNzYyWiIgZmlsbD0iI0U2RjZGRiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/polygon.svg
// module id = 134
// module chunks = 1